import XLSX from 'xlsx'

class importSettingSettingCtrl {
    constructor($scope, $location, logger, httpRequest, $state) {
        const _templateId = $state.params.id
        const _templateType = $state.params.type
        let isExist = false
        const isNumReg = /^[3-9]+$/
        const isAbcReg = /^[a-zA-Z]+$/
        // 初始化导入参数
        $scope.resData = []
        // 初始化表单数据
        httpRequest.post_getSysFileFields({
            templateId: _templateId,
        }).then((res) => {
            const _data = res.data
            if (_data.success && _data.value.length === 0) {
                // 如果为空则请求类型数据
                httpRequest.post_getSysFileTypeFields({
                    templateType: _templateType,
                }).then((res1) => {
                    if (res1.data.success && res1.data.value.length > 0) {
                        $scope.resData = res1.data.value
                    }
                })
            } else {
                // 设置参数
                $scope.resData = _data.value
                isExist = true
            }
        })

        // 序号变化
        $scope.fieldOrderChange = function (item, index) {
            // field array
            if (!item.fieldOrder) {
                return
            }
            if (!isAbcReg.test(item.fieldOrder)) {
                logger.logError('顺序为字母，支持大小写')
                return
            }
            const fieldArray = $scope.resData.map((o) => o.fieldOrder)
            const fieldOrderIndex = fieldArray.indexOf(item.fieldOrder)
            const tipSameNumEnd = Number(fieldOrderIndex) + 1
            const tipSameNumStart = Number(index) + 1

            if (fieldOrderIndex > -1 && fieldOrderIndex !== index) {
                logger.logError(`第${tipSameNumStart}项与第${tipSameNumEnd}项顺序不能相同`)
            }
        }
        // 文件信息
        $scope.fileInfo = {
            filename: '',
            filesize: '',
            startLine: 3,
        }
        $scope.startLineChange = function () {
            if (!isNumReg.test($scope.fileInfo.startLine)) {
                logger.logError('读取行数，必须是大于2的整数')
                $scope.fileInfo.startLine = 3
            }
        }
        function fixdata(data) { // 文件流转BinaryString
            let o = ''
            let l = 0
            const w = 10240
            for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
            o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
            return o
        }
        $scope.uploadFiles = function (file, errFiles) {
            // 不符合文件格式的错误提示
            if (file == null && errFiles.length >= 1) {
                logger.logError('文件类型错误，文件大小不超过5m，支持.xlsx,.xls,.txt格式')
                return
            }
            if (file) {
                console.log(file)
                $scope.fileInfo.filename = file.name
                $scope.fileInfo.filesize = file.size

                const reader = new FileReader()
                let wb// 读取完成的数据
                const rABS = false // 是否将文件读取为二进制字符串
                reader.onload = function (e) {
                    const data = e.target.result
                    if (rABS) {
                        wb = XLSX.read(btoa(fixdata(data)), { // 手动转化
                            type: 'base64',
                        })
                    } else {
                        wb = XLSX.read(data, {
                            type: 'binary',
                        })
                    }
                    // wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
                    // wb.Sheets[Sheet名]获取第一个Sheet的数据

                    // console.log(wb)
                    // console.log( JSON.stringify( XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]) ) ) ;
                }
                if (rABS) {
                    reader.readAsArrayBuffer(file)
                } else {
                    reader.readAsBinaryString(file)
                }
            }
        }

        $scope.submit = function () {
            const fieldArray = $scope.resData.map((o) => o.fieldOrder)
            for (let i = 0, l = $scope.resData.length; i < l; i++) {
                const index = i + 1
                console.log($scope.resData[i].fieldOrder)
                if ($scope.resData[i].fieldOrder === '' || $scope.resData[i].fieldOrder === null) {
                    logger.logError(`第${index}项顺序不能为空！`)
                    return false
                }

                if (!isAbcReg.test($scope.resData[i].fieldOrder)) {
                    logger.logError(`第${index}项顺序格式错误，顺序为字母，支持大小写`)
                    return false
                }

                const fieldOrderIndex = fieldArray.indexOf($scope.resData[i].fieldOrder)
                const orderIndex = fieldOrderIndex + 1
                console.log(i)
                console.log(fieldOrderIndex)
                if (fieldOrderIndex > -1 && fieldOrderIndex !== i) {
                    logger.logError(`第${index}项与第${orderIndex}项顺序不能相同`)
                    return false
                }
            }


            if (isExist) {
                httpRequest.post_saveSysFileFields($scope.resData, '保存成功')
            } else {
                httpRequest.post_addSysFileTypeFields($scope.resData, '新增成功')
            }
        }

        $scope.cancel = function () {
            $location.path('/system/settingcenter/importSetting/list').replace()
            return false
        }
    }
}

importSettingSettingCtrl.$inject = ['$scope', '$location', 'logger', 'httpRequest', '$state']
export default importSettingSettingCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/importSetting/importSettingSettingCtrl.js